import React from 'react'
import { NavLink } from 'react-router-dom'
import { ReactComponent as BorrowIcon } from './icons/borrow.svg'
import { ReactComponent as LendIcon } from './icons/lend.svg'
import { ReactComponent as TradeIcon } from './icons/trade.svg'
import { routes } from 'bzx-common/src/config/appConfig'

export function DashboardFooter() {
  return (
    <nav className="dashboard__footer ">
      <NavLink className="btn btn--medium btn--menu flex-center" to={routes.tradeChart}>
        <TradeIcon className="dashboard__footer-icon" />
        <span className="margin-left-1ch">Trade</span>
      </NavLink>
      <NavLink className="btn btn--medium btn--menu flex-center" to="/lend">
        <LendIcon className="dashboard__footer-icon" />
        <span className="margin-left-1ch">Lend</span>
      </NavLink>
      <NavLink className="btn btn--medium btn--menu flex-center" to="/borrow">
        <BorrowIcon className="dashboard__footer-icon" />
        <span className="margin-left-1ch">Borrow</span>
      </NavLink>
    </nav>
  )
}

export default React.memo(DashboardFooter)
